import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterTagsValue,
  UniversalFilterTagsModes,
  UniversalFilterTagsFilterState,
  UniversalFilterTagsOnChange
} from '../../UniversalFilterTags.types';

interface UniversalFilterTagsFilterStateOptions {
  onChange: UniversalFilterTagsOnChange;
}

function useUniversalFilterTagsFilterState({
  onChange
}: UniversalFilterTagsFilterStateOptions) {
  // All modes and options available in handleApplyFilterState
  // must be implemented in handleParseFilterValue too
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterTagsFilterState) => void
  >(
    (filterState) => {
      const tagIds = filterState?.tagIds;

      if (filterState?.mode === UniversalFilterTagsModes.CONTAINS_ANY_OF) {
        onChange(isEmpty(tagIds) ? undefined : tagIds);
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterTagsValue
    ) => UniversalFilterTagsFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue)) {
      return {
        mode: UniversalFilterTagsModes.CONTAINS_ANY_OF,
        tagIds: filterValue
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterTagsFilterState;
